import { ButtonColor } from "@/common/enum/button-color";
import { AdminAdminPath } from "@/common/enum/path";
import { formatPhoneNumber } from "@/common/util/format-phone-number";
import { AdminMyProfileHeader } from "@/components/header/AdminMyProfileHeader";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { userService } from "@/services/user-service";
import { Button } from "flowbite-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { toastState } from "../../atoms/system/toast-state";
import { profileState } from "../../atoms/user/profile-state";
import { validatePhoneNumber } from "../../common/validator/validate-phone-number";
import { AdminPasswordModal } from "../../components/modal/AdminPasswordModal";
import { AdminMyDetailTable } from "../../components/table/admin-my-detail-table/AdminMyDetailTable";

export default function AdminMyProfilePage() {
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useRecoilState(profileState);
  const [inputs, setInputs] = useState({
    departmentId: profile.department?.id || 0,
    phone: profile.phone,
  });
  const setToast = useSetRecoilState(toastState);
  const navigate = useNavigate();

  const modalOpen = () => {
    setOpen(true);
  };

  const modalClose = () => {
    setOpen(false);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    setInputs({ ...inputs, phone: formattedValue });
  };

  const handleDepartmentChange = (departmentId: number) => {
    setInputs({ ...inputs, departmentId });
  };

  const updateProfile = async () => {
    try {
      const isValidPhone = validatePhoneNumber(inputs.phone);
      if (!isValidPhone) {
        // setToast({
        //   show: true,
        //   messages: ["올바른 전화번호를 입력해주세요."],
        // });
        return;
      }
      const updateAdminAsyncResponse = await userService.updateAdminAsync(
        profile.id!,
        {
          phone: inputs.phone,
          departmentId: inputs.departmentId,
        }
      );
      if (!updateAdminAsyncResponse.ok) {
        return;
      }
      const getMeResponse = await userService.getMe();
      if (!getMeResponse.ok) {
        return;
      }
      setProfile(getMeResponse.data);
      setToast({
        show: true,
        messages: [`변경된 정보를 저장했습니다.`],
      });
      navigate(AdminAdminPath.PROFILE);
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   if (profile?.role === UserRole.ADMIN) {
  //     return;
  //   }
  //   navigate("/home");
  // }, [profile]);

  // TODO : departmentId가 0일 때 서버에서 department null 처리

  const disabled =
    !validatePhoneNumber(inputs.phone) || // 연락처가 없을 때
    (inputs.phone === profile?.phone &&
      inputs.departmentId === profile?.department?.id) ||
    (!inputs.phone && !inputs.departmentId);

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1648px] h-full items-between justify-start gap-[16px]">
        <AdminMyProfileHeader
          disabled={disabled}
          onClickButton={updateProfile}
        />
        {profile && (
          <AdminMyDetailTable
            user={profile}
            phone={inputs.phone}
            departmentId={inputs.departmentId}
            handlePhoneChange={handlePhoneChange}
            handleDepartmentChange={handleDepartmentChange}
          />
        )}
        <div>
          <Button color={ButtonColor.TRANSPARENT_OUTLINE} onClick={modalOpen}>
            비밀번호 변경하기
          </Button>
        </div>
      </div>
      {profile && open && (
        <AdminPasswordModal user={profile} closeModal={modalClose} />
      )}
    </PageWrapper>
  );
}
